import { render, staticRenderFns } from "./ProductSalesPriceDetailTemp.vue?vue&type=template&id=b05e9dea&"
import script from "./ProductSalesPriceDetailTemp.vue?vue&type=script&lang=js&"
export * from "./ProductSalesPriceDetailTemp.vue?vue&type=script&lang=js&"
import style0 from "./ProductSalesPriceDetailTemp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports